import { render, staticRenderFns } from "./CmgPasswordResetPage.vue?vue&type=template&id=016abcd0&scoped=true&lang=pug&"
import script from "./cmg-password-reset-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-password-reset-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPasswordResetPage.vue?vue&type=style&index=0&id=016abcd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016abcd0",
  null
  
)

export default component.exports